import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone:true,
  imports:[CommonModule],
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input()
  public title: string = '';

  constructor() {
  }

  ngOnInit(): void {
  }

  onClickContact() {
    window['orgUtil'].showSupportModal();
  }

  onClickNew() {
    window['$']('#whatsNewModel').modal('show');
  }

}
